<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        <a href="#" @click.prevent="goBack"><i class="fa fa-angle-left"></i></a>
        Trazabilidad: Paletizaje Pallet ({{ PalletNumber }})
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div v-if="itemsProcess != ''">
              <h4>El pallet ({{ PalletNumber }}) fue paletizado</h4>
              <b-table striped hover small :items="itemsProcess" :fields="fieldsProcess">
                <template v-slot:cell(Fecha_Proceso)="data">
                  {{ data.item.Fecha | moment }}
                </template>

                <template v-slot:cell(Numero_Proceso)="data">
                  <a
                    target="_blank"
                    href="#"
                    title="Ver en detalle"
                    @click.prevent="
                      seeProcessDetail(data.item.process_id, data.item.Numero_Proceso, data.item.process_option)
                    "
                    >{{ data.item.Numero_Proceso }}</a
                  >
                </template>

                <template v-slot:cell(Detalle)="data">
                  <a
                    target="_blank"
                    href="#"
                    title="Detalle"
                    @click.prevent="showProcessModal(data.item.process_id, data.item.process_option)"
                    class="fa fa-lg fa-search text-primary text-right"
                  ></a>
                </template>
              </b-table>
            </div>

            <div v-show="cargaAux == 1">
              <h4>El pallet ({{ PalletNumber }}) no fue paletizado</h4>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="infoModalProcess" centered size="xl" title="Reporte de proceso" @ok="closeModal" ok-only>
      <div class="text-center">
        <b-spinner v-if="loading" label="Spinning"></b-spinner>
      </div>
      <component :is="ReportProcess" :process="process" ref="ReportProcess"></component>
    </b-modal>

    <b-modal ref="infoModalRepa" centered size="xl" title="Reporte de repaletizaje" @ok="closeModal" ok-only>
      <div class="text-center">
        <b-spinner v-if="loading" label="Spinning"></b-spinner>
      </div>
      <component
        :is="componenteActual"
        :process="tableDataPalletIn"
        :tableDataMovimientos="tableDataMovimientos"
        ref="ReportRepaletizaje"
      ></component>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Report from "../recepcion/Report.vue";
import ReportProcess from "../procesos/Report2.vue";
import ReportRepaletizaje from "../procesos/ImprimirRepaletizaje.vue";

export default {
  name: "DetalleTrazabilidadProcess",
  props: ["PalletID", "ContentID", "PalletNumber"],
  components: {
    Report,
    ReportProcess,
    ReportRepaletizaje
  },
  created() {},
  data() {
    return {
      fieldsProcess: ["Tipo_Proceso", "Fecha_Proceso", "Numero_Proceso", { key: "Detalle", class: "text-right" }],
      itemsProcess: [],
      cargaAux: 0,
      process: [],
      tableDataPalletIn: [],
      tableDataMovimientos: [],
      loading: false,
      componenteActual: ""
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY HH:MM");
    }
  },
  methods: {
    seeProcessDetail(process_id, numProcess, tipoProceso) {
      if (tipoProceso == 1) {
        this.$router.push("/trazabilidad/detailed-process/" + process_id + "/" + numProcess);
      }

      if (tipoProceso == 2) {
        this.$router.push("/trazabilidad/detailed-repaletizaje/" + process_id + "/" + numProcess);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    checkProcess() {
      this.$axios
        .get("/api/v1/content/check_process_repaletting_content/", {
          params: {
            id: this.ContentID,
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.itemsProcess = [];

          const datos = res.data.data;

          for (let key in datos) {
            var rowNew = {
              process_option: datos[key].process.process_type.process_option,
              Tipo_Proceso: datos[key].process.process_type.name,
              Fecha: datos[key].process.start_time,
              Numero_Proceso: datos[key].process.number,
              process_id: datos[key].process.id,
              IDContenido: datos[key].content.id,
              Acción: datos[key].content_type == 2 ? "Entra de proceso" : "Sale de proceso"
            };

            this.itemsProcess.push(rowNew);
          }

          if (this.itemsProcess.length == 0) {
            this.cargaAux = 1;
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    getProcess(process_id) {
      this.$axios
        .get("/api/v1/process/" + process_id + "/detailed_with_traceability/")
        // .then(x => new Promise(resolve => setTimeout(() => resolve(x), 2000)))
        .then((res) => {
          this.process = res.data;
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
    getProcessRepa(process_id) {
      this.tableDataPalletIn = [];
      this.tableDataMovimientos = [];

      this.$axios
        .get("/api/v1/process/" + process_id + "/process_detail_repaletizaje/")
        .then((res) => {
          this.tableDataPalletIn = res.data.movement_content;
          this.loading = false;

          const datos = res.data.movement_content;

          for (let key in datos) {
            var rowNew = {
              Pallet_entrada: datos[key].content.pallet_number,
              Pallet_salida: datos[key].content_reference.pallet_number,
              Producto: datos[key].content.product_name,
              Tipo_producto: datos[key].content.product_type_name,
              Variedad: datos[key].content.variety_name,
              origin: datos[key].content_reference.origin_name,
              kilos_brutos: datos[key].content.gross_kilograms,
              kilos_netos: datos[key].content.net_kilograms,
              Cantidad: datos[key].content.quantity,
              IDContenido: datos[key].content.id,
              container: datos[key].content_reference.container.name,
              condition: datos[key].content_reference.condition,
              variety: datos[key].content_reference.variety_name,
              creation_date: datos[key].content_reference.creation_date,
              plant: datos[key].content_reference.plant
            };

            this.tableDataMovimientos.push(rowNew);
          }
        })
        .catch((error) => console.log(error.message));
    },
    showProcessModal(a, typeProcess) {
      if (typeProcess == 1) {
        this.ReportProcess = "ReportProcess";
        this.loading = true;
        this.$nextTick(function () {
          this.getProcess(a);
        });

        this.$refs.infoModalProcess.show();
      }

      if (typeProcess == 2) {
        this.componenteActual = "ReportRepaletizaje";
        this.loading = true;
        this.$nextTick(function () {
          this.getProcessRepa(a);
        });

        this.$refs.infoModalRepa.show();
      }
    },
    closeModal() {
      this.$refs.report.process = [];
      this.process = [];
      this.ReportProcess = "";
    }
  },
  mounted() {
    this.checkProcess();
    // alert(this.PalletID);
    this.cargaAux = 0;
  }
};
</script>
